const supportedOrganisations = [
    {"value": "na", "label": "Nelson Alexander"},
    {"value": "rt", "label": "RT Edgar"}
]

export default supportedOrganisations;